// @MX:ANCHOR: [AUTO] Lot/Batch 통합 추적 API 모듈 — china-inapi GET /lot-trace/:value
// @MX:REASON: [AUTO] LotTrace 화면 + 4개 목록 화면 cross-link 모두 이 모듈을 통해 china-inapi 호출. SPEC-CHINA-LOT-BATCH-TRACEABILITY-001 REQ-FE-TRC-002
// @MX:SPEC: SPEC-CHINA-LOT-BATCH-TRACEABILITY-001

import chinaInapi from './chinaInapi';

/**
 * Lot/Batch 통합 추적 API — REQ-FE-TRC-002
 * GET /lot-trace/:value
 *
 * 응답 shape: §3.2.4 lot-trace endpoint 응답 스키마
 *   value, matchedKeys, ecountTransactions, dealerPurchaseInbounds,
 *   dealerInventorySnapshots, dealerSalesOutbounds, panelStatus, anomalies
 */
const lotTraceApi = {
  /**
   * lot/batch 통합 추적 — 4 컬렉션 parallel lookup
   * @param {string} value - lotNumber / batchNumber / batchCode 값
   * @returns {Promise} 응답 스키마 §3.2.4
   */
  traceLot(value) {
    const encoded = encodeURIComponent(value);
    return chinaInapi.get(`/lot-trace/${encoded}`);
  },
};

export default lotTraceApi;
